import React, { useEffect, useRef } from "react";
import { typeHelpModelViewer, typeModelsProject } from "../../assets/type_assets";
import { onProgressModel } from "./methodsModelViewer";
import "./modelviewer.css";

export const IframeModelViewer = ({ selectModel = { model: "", poster: "" } }) => {
	const modelviewer = useRef(null);

	useEffect(() => {
		if (modelviewer.current !== "") {
			modelviewer.current.addEventListener("progress", (event) => {
				onProgressModel(event);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="xxsm:h-[350px] xsm:h-[500px]">
			<model-viewer
				ref={modelviewer}
				src={selectModel.model}
				ar
				ar-modes="scene-viewer webxr quick-look"
				camera-controls
				poster={selectModel.poster}
				shadow-intensity="1"
				autoplay
				exposure="1.30"
				environment-image={typeModelsProject.hrd}
			>
				<div className="progress-bar hide" slot="progress-bar">
					<div className="update-bar"></div>
				</div>
				<button id="ar-button" slot="ar-button">
					<div className="boxViewAr bosShadowButton">
						<div className="flex justify-center gap-2">
							<div className="imagear" />
							<span className="font-bold text-[14px]">AR Experience</span>
						</div>
					</div>
				</button>
				<div id="ar-prompt">
					<img src={typeHelpModelViewer.handhelp} alt="prueba" />
				</div>
			</model-viewer>
		</div>
	);
};
